import { httpClient } from '@/services/http/httpClient'

export type UnlinkIdeaParams = {
  ideaId: string
  ideaIdToUnlink: string
}

export async function unlinkIdea({ ideaId, ideaIdToUnlink }: UnlinkIdeaParams) {
  const searchParams = new URLSearchParams({
    primaryIdeaId: ideaId,
    secondaryIdeaId: ideaIdToUnlink,
  })

  await httpClient.delete(`ideas/idea-links/unlink?${searchParams.toString()}`)
}
